import { radioAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
import { colors } from "../tokens/colors";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(radioAnatomy.keys);

type CustomRadioTheme = {
  showborders?: "true" | "false";
};

const baseStyle = definePartsStyle((props) => {
  const { showborders } = props as CustomRadioTheme;
  return {
    control: {
      appearance: "none",
      borderRadius: "30%",
      margin: 0,
      cursor: "pointer",
      borderColor: colors.neutral[500],
      _checked: {
        borderColor: colors.primary[500],
        backgroundColor: "transparent",
        _before: {
          content: '""',
          display: "inline-block",
          width: "60%",
          height: "60%",
          borderRadius: "20%",
          backgroundColor: colors.primary[500],
        },
      },
    },
    container: {
      width: "100%",
      borderRadius: "1rem",
      border: `2px solid ${
        showborders === "true" ? "rgba(255, 255, 255, 0.15)" : "transparent"
      }`,
      px: "0.5rem",
      py: "0",
      ps: "0.875rem",
      transition: "all 0.2s",
      _hover: {
        bg: `${showborders === "true" ? "rgba(255, 255, 255, 0.1)" : "none"}`,
        borderColor: "rgba(255, 255, 255, 0.15)",
      },
      _checked: {
        border: `2px solid transparent`,
        boxShadow: colors.shadow.primary,
      },
    },
    label: {
      padding: 0,
      ml: "-0.5rem",
    },
  };
});

// Define variants
const success = definePartsStyle({
  control: {
    borderColor: colors.neutral[500],
    _checked: {
      borderColor: "green.600",
      _before: {
        backgroundColor: "green.600",
      },
    },
  },
  container: {
    _checked: {
      border: `2px solid`,
      borderColor: "green.600",
      boxShadow: colors.shadow.success,
    },
  },
});

const error = definePartsStyle({
  control: {
    borderColor: colors.neutral[500],
    _checked: {
      borderColor: "red.500",
      _before: {
        backgroundColor: "red.500",
      },
    },
  },
  container: {
    _checked: {
      border: "2px solid red.500",
      boxShadow: colors.shadow.error,
    },
  },
});

const warning = definePartsStyle({
  control: {
    borderColor: colors.neutral[500],
    _checked: {
      borderColor: "yellow.500",
      _before: {
        backgroundColor: "yellow.500",
      },
    },
  },
  container: {
    _checked: {
      border: "2px solid yellow.500",
      boxShadow: colors.shadow.warning,
    },
  },
});

export default defineMultiStyleConfig({
  baseStyle,
  variants: {
    success,
    error,
    warning,
  },
});
